angular
  .module("AccountingBoxApp")
  //   .directive("datePicker", function() {
  //   return {
  //     restrict: "A",
  //     require: "ngModel",
  //     link: function(scope, element, attrs, ctrl) {
  //       $(element).datepicker({
  //         language: "nl",
  //         todayHighlight: true,
  //         format: "dd-mm-yyyy",
  //         autoclose: true,
  //         onSelect: function(date) {
  //           ctrl.$setViewValue(date);
  //           ctrl.$render();
  //           scope.$apply();
  //         }
  //       });
  //     }
  //   };
  // })
  .directive("abDatePicker", function($timeout) {
    return {
      restrict: "A",
      require: "?ngModel",
      scope: {
        onSelect: "&"
      },
      link: function(scope, element, attrs, ngModelController) {
        // Private variables
        var datepickerFormat = "dd-mm-yyyy",
          momentFormat = "DD-MM-YYYY",
          datepicker,
          elPicker;

        // Init date picker and get objects http://bootstrap-datepicker.readthedocs.org/en/release/index.html
        datepicker = element.datepicker({
          language: "nl",
          autoclose: true,
          keyboardNavigation: false,
          todayHighlight: true,
          format: datepickerFormat,
          orientation: 'bottom'
        });
        elPicker = datepicker.data("datepicker").picker;

        // Adjust offset on show
        datepicker.on("show", function(evt) {
          elPicker.css("left", parseInt(elPicker.css("left")) + +attrs.offsetX);
          elPicker.css("top", parseInt(elPicker.css("top")) + +attrs.offsetY);
        });

        // Only watch and format if ng-model is present https://docs.angularjs.org/api/ng/type/ngModel.NgModelController
        if (ngModelController) {
          // So we can maintain time
          var lastModelValueMoment;

          ngModelController.$formatters.push(function(modelValue) {
            //
            // Date -> String
            //

            // Get view value (String) from model value (Date)
            var viewValue,
              m = moment(modelValue);
            if (modelValue && m.isValid()) {
              // Valid date obj in model
              lastModelValueMoment = m.clone(); // Save date (so we can restore time later)
              viewValue = m.format(momentFormat);
            } else {
              // Invalid date obj in model
              lastModelValueMoment = undefined;
              viewValue = undefined;
            }

            // Update picker
            element.datepicker("update", viewValue);

            // Update view
            return viewValue;
          });

          ngModelController.$parsers.push(function(viewValue) {
            //
            // String -> Date
            //

            // Get model value (Date) from view value (String)
            var modelValue,
              m = moment(viewValue, momentFormat, true);
            if (viewValue && m.isValid()) {
              // Valid date string in view
              if (lastModelValueMoment) {
                // Restore time
                m.hour(lastModelValueMoment.hour());
                m.minute(lastModelValueMoment.minute());
                m.second(lastModelValueMoment.second());
                m.millisecond(lastModelValueMoment.millisecond());
              }
              modelValue = m.toDate();
            } else {
              // Invalid date string in view
              modelValue = undefined;
            }

            // Update model
            return modelValue;
          });

          datepicker.on("changeDate", function(evt) {
            // Only update if it's NOT an <input> (if it's an <input> the datepicker plugin trys to cast the val to a Date)
            if (evt.target.tagName !== "INPUT") {
              ngModelController.$setViewValue(
                moment(evt.date).format(momentFormat)
              ); // $seViewValue basically calls the $parser above so we need to pass a string date value in
              ngModelController.$render();
            }
            if (scope.onSelect) {
              $timeout(function() {
                scope.onSelect({ date: evt.date });
              });
            }
          });
        }
      }
    };
  });

// .directive("abDatePicker", function() {
//   return {
//     restrict: "A",
//     require: "ngModel",
//     link: function(scope, elem, attrs, ngModelCtrl) {
//       elem.on("changeDate", updateModel);
//       elem.datepicker({});
//
//       function updateModel(event) {
//         ngModelCtrl.$setViewValue(event.date);
//       }
//     }
//   };
// });
// .directive("abDatePicker", function() {
//   return {
//     restrict: "A",
//     require: "ngModel",
//     scope: {
//       ngModel: "=",
//       minDate: "=",
//       maxDate: "=",
//       dateChanged: "&"
//     },
//     link: function(scope, elem, attrs, ngModelCtrl) {
//       var updateModel = function(dateText) {
//         scope.$apply(function() {
//           ngModelCtrl.$setViewValue(dateText);
//         });
//       };
//       var options = {
//         language: "nl",
//         format: "dd-mm-yyyy",
//         autoclose: true,
//         yearRange: "2010:Y"
//         // onClose: function(ele) {
//         //   this.blur();
//         // },
//         // defaultDate: new Date()
//       };
//       $(elem)
//         .datepicker(options)
//         .on("change", function(e) {
//           console.log("on change e date", e.date);
//           console.log("on change scope date", scope.date);
//           console.log("on change scope date", e.target.value);
//           var dateText = e.target.value;
//           var date = moment(dateText, "DD-MM-YYYY").toDate();
//           updateModel(date);
//           // scope.dateChanged({ date: date });
//         });
//       //
//       scope.$watch("ngModel", function(newValue, oldValue) {
//         console.log("ngmodel changed old", oldValue);
//         console.log("ngmodel changed new", newValue);
//
//         if (newValue) {
//           return $(elem).datepicker("setDate", null);
//         }
//         if (newValue !== oldValue) {
//           $(elem).datepicker("setDate", newValue);
//         }
//       });
//       //
//       // scope.$watch("maxDate", function(newValue, oldValue) {
//       //   $(elem).datepicker("option", "maxDate", newValue);
//       // });
//       //
//       // scope.$watch("minDate", function(newValue, oldValue) {
//       //   $(elem).datepicker("option", "minDate", newValue);
//       //   $(elem).datepicker("option", "defaultDate", newValue);
//       // });
//     }
//   };
// });
